import * as React from 'react';

import classNames from 'classnames';

import { IOuterWrapperProps } from './types';

import * as s from './OuterWrapper.scss';

interface IOuterWrapperState {
}

export class OuterWrapper extends React.PureComponent<IOuterWrapperProps, IOuterWrapperState> {

	state: IOuterWrapperState = {
		isLoading: true,
	};

	render() {
		const {
			className,
		} = this.props;

		return (
			<section className={classNames(
				s.block,
				className,
			)}>
				{this.props.children}
			</section>
		);
	}

}
